import { render } from "./PersonalizedSidebar.vue?vue&type=template&id=9635aef4&scoped=true"
import script from "./PersonalizedSidebar.vue?vue&type=script&lang=js"
export * from "./PersonalizedSidebar.vue?vue&type=script&lang=js"

import "./PersonalizedSidebar.vue?vue&type=style&index=0&id=9635aef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9635aef4"]])

export default __exports__